<!--客流列表-->
<template>
    <div class="customerList-module">
        <form action="/">
            <van-search class="search-button" v-model="searchStr" @search="onSearch" @clear="selClear" placeholder="搜索姓名/手机/会员卡号"
                left-icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-07/search.png">
            </van-search>
        </form>
        <div class="select-box flex flex-y-center flex-start">
            <div v-if="postId==1||postId==3||postId=='1472787652026766338'||postId=='1472787652026765367'||postId=='1472787652026765362'"
                class="select-item select-item-second flex flex-between flex-y-center" @click="selectEmployeePopup">
                <div class="select-tit">{{checkedEmployee && checkedEmployee.name}}</div>
                <van-icon name="play" class="select-arrow" />
            </div>
            <div class="select-item select-item-second flex-start flex-y-center" @click="selectTimePopup">
                <div class="select-tit">{{dateTxt}}</div>
                <van-icon name="play" class="select-arrow" />
            </div>
        </div>
        <div class="interval">
        </div>
        <div class="table">
            <div class="table-tab flex flex-x-center flex-between ">
                <div :class="`tab-item ${tabIndex == 1?'active':''}`" @click="clickTab(1)">
                    非0元客流({{nonZeroCount}})
                </div>
                <div :class="`tab-item  item-text ${tabIndex == 0?'active':''}`" @click="clickTab(0)">
                    0元客流({{zeroCount}})
                </div>
            </div>
            <div class="box-line"></div>
            <div class="table-list">
                <div class="bg-w  flex-y-center  flex-between">
                    <div class="header-title align-center" style="width:110px">顾客</div>
                    <div class="header-title align-center">所属门店</div>
                    <div class="header-title align-center">支付净额</div>
                    <div class="header-title align-center" style="width:110px">到店时间</div>
                </div>
                <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
                    <div class="data-list" v-if="customerList.length > 0">
                        <!-- 下拉刷新 -->
                        <van-list v-model="loading" :finished="finished" :loading="loading" finished-text="没有更多了" @load="onLoad()"
                            :offset="20" :immediate-check="false">
                            <div v-for="(item,index) in customerList" :key="index">
                                <div class="tr line flex-y-center  flex-between" @click="toDetail(item.id,item.mobile)">
                                    <div class="custName-td flex-between flex-x-center " style="width:110px">
                                        <img v-if="item.cardImageSmallUrl" class="levelCodeImg" referrerpolicy="no-referrer"
                                            alt="" :src="item.cardImageSmallUrl" />
                                        <div class="custName ellipsis ">{{item.name}}</div>
                                    </div>
                                    <div class="td">
                                        <div>{{item.storeName}}</div>
                                    </div>
                                    <div class="td">
                                        <div>{{item.payedAmt}}</div>
                                    </div>
                                    <div class="td" style="width:110px">
                                        <div class="td-item">{{item.createDate}}</div>
                                    </div>
                                </div>
                            </div>
                        </van-list>
                    </div>
                    <div v-else class="data-list" style="margin:80px auto">
                        <van-empty
                            image="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-14/null.png"
                            description="暂无数据" />
                    </div>
                </van-pull-refresh>

            </div>
        </div>
        <van-popup v-model="showEmployeePopup" round position="bottom" closeable class="popup">
            <picker title="全部员工" @handle="checkedEmployee" v-model="checkedEmployee" :list="employeeList"
                @change="onEmployeeChange"></picker>
        </van-popup>
        <van-popup v-model="showTimePopup" round position="bottom" closeable class="popup">
            <date-picker v-model="dateType" @submit="handleDate" :pickerType="pickerType"></date-picker>
        </van-popup>
    </div>
</template>

<script>
import request from "@/utils/request";
import DatePicker, { getDateText, getFormatTime, PICKER_TYPE } from '@/components/DatePicker';
import Picker from '@/components/Picker';
import { Search, Toast } from "vant";
import { getCookie } from '@/utils'


export default {
    name: "passengerFlowList",
    components: {
        [Search.name]: Search, DatePicker, Picker
    },
    data() {
        return {
            pickerType: PICKER_TYPE.DAY,// 日期类型
            dateType: '1', // 日期
            beginMonth: '', // 开始日期
            endMonth: '', // 结束日期
            tabIndex: 1, // tab栏下标
            showTimePopup: false,//选择时间弹窗
            showEmployeePopup: false, //选择员工弹窗
            searchStr: '',  // 搜索条件
            page: 1,       //当前页
            customerList: [],    //客流列表
            loading: false,    //加载
            finished: false,    //结束加载
            refreshing: false,   //刷新
            limit: 10,       //每页多少条
            employeeList: [],  //员工列表
            checkedEmployee: { id: 0, name: '全部员工' },
            total: 0,   //当前类型客流数据
            nonZeroCount: 0,   //非元客流数据
            zeroCount: 0,   //0元客流数据
            postId: '', // 岗位
        };
    },
    computed: {
        dateTxt() {
            return getDateText(this.dateType, this.beginMonth, this.endMonth, this.pickerType)
        }
    },
    mounted() {
        this.postId = getCookie('postId') || localStorage.getItem('postId');
        this.getEmpList();
        this.onLoad();
    },
    methods: {
        onLoad() {
            this.loading = true
            const beginDate = getFormatTime(this.beginMonth, this.pickerType)
            const endDate = getFormatTime(this.endMonth, this.pickerType)
            request({
                url: "/custCount/customerTrafficDetail?beginMonth=" + beginDate +
                    "&endMonth=" + endDate +
                    "&dateType=" + this.dateType +
                    '&creator=' + this.checkedEmployee.id +
                    '&isZero=' + this.tabIndex +
                    '&memberNameAndMobile=' + this.searchStr +
                    '&page=' + this.page,
                method: "get",
            })
                .then((res) => {
                    this.customerList = this.page == 1 ? res.data.page.list : this.customerList.concat(res.data.page.list);
                    this.page += 1;
                    this.nonZeroCount = res.data.nonZeroCount;
                    this.zeroCount = res.data.zeroCount;
                    this.total = res.data.page.total;
                }).catch((error) => {
                    this.finished = true
                    Toast({ position: 'top', message: error ?? '' })
                }).finally(() => {
                    this.loading = false;
                    this.refreshing = false;
                    if (this.customerList.length >= this.total) {
                        this.finished = true;
                    }
                });
        },
        //搜索
        onSearch() {
            this.page = 1
            this.onLoad();
        },
        onRefresh() {
            this.page = 1
            // 清空列表数据
            this.finished = false;
            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.customerList = [];
            this.refreshing = false;
            this.onLoad();
        },
        //详情页
        toDetail(custId, phone) {
            this.$router.push({ name: "customerDetail", query: { custId: custId, phone: phone } });
        },
        //清除搜索
        selClear() {
            this.searchStr = "";
            this.page = 1
            this.onLoad();
        },
        //员工选择
        selectEmployeePopup() {
            this.showEmployeePopup = true;
        },
        // 时间弹窗
        selectTimePopup() {
            this.showTimePopup = true
        },

        //员工筛选
        onEmployeeChange(data) {
            this.page = 1
            this.checkedEmployee = data
            this.showEmployeePopup = false
            this.onRefresh();
        },

        // 时间确定
        handleDate(id, begin, end) {
            this.page = 1
            this.showTimePopup = false
            this.dateType = id
            if (!id) {
                this.beginMonth = begin
                this.endMonth = end
            } else {
                this.beginMonth = ''
                this.endMonth = ''
            }
            this.onRefresh();
        },

        // tab切换
        clickTab(tabIndex) {
            this.tabIndex = tabIndex;
            this.onRefresh();
        },

        // 获取员工列表
        getEmpList() {
            request({
                url: "/workEmployee/getEmployeeList",
                method: "get",
            })
                .then((res) => {
                    this.employeeList = res.data
                    this.checkedEmployee = this.employeeList[0] //默认全部
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
        },

    },
};
</script>

<style scoped lang="less">
::-webkit-scrollbar {
    display: none;
}
.select-box {
    margin-left: 30px;
    .select-tit {
        font-size: 28px;
        color: #35434c;
    }
    .select-arrow {
        transform: rotate(90deg);
        font-size: 24px;
        margin-left: 10px;
    }
    .select-item-second {
        // margin-left: 50px;
        margin-right: 50px;
    }
}

.table-tab {
    width: 100%;
    height: 100%;
    display: flex;
    margin: 30px 0 0 0px;
}

.tab-item {
    width: 250px;
    height: 42px;
    font-size: 30px;
    font-weight: 400;
    color: #a0acb5;
    text-align: center;
    position: relative;
}

.item-text {
    margin-left: 152px;
}
.tab-item.active {
    color: #35434c;
    font-weight: bold;
}
.tab-item.active::after {
    position: absolute;
    bottom: -15px;
    content: "";
    width: 110px;
    height: 4px;
    background: #37dbe0;
    left: 50%;
    transform: translateX(-50%);
}

.box-line {
    width: 690px;
    height: 1px;
    background: #d7d7d7;
    margin: 15px 0 0 30px;
}
.table-list {
    border: 0px solid darkgray;
    padding: 30px;
    height: 100%;
}
.bg-w {
    display: flex;
    width: 100%;
    height: 80px;
    align-items: center;
    background: #fafafe;
    // padding: 0 40px 0 0;
}

.header-title {
    width: 140px;
    font-size: 26px;
    color: #66757f;
}
.custName {
    margin-left: 10px;
}
.data-list {
    height: 80vh; //calc(100vh - 302px);
    overflow-y: auto;
}

.tr {
    display: flex;
    width: 100%;
    height: 80px;
    border-bottom: 1px solid #d7d7d7;
}
.custName-td {
    width: 140px;
    justify-content: flex-start;
    text-align: left;
    font-size: 28px;
    color: #35434c;
    align-items: center;
}
.td {
    width: 140px;
    justify-content: center;
    text-align: center;
    font-size: 28px;
    color: #35434c;
}
.td-item {
    margin-bottom: 17px;
}
.line {
    height: 146px;
}
.th {
    width: 40%;
    justify-content: center;
    background: #fafafe;
    color: #66757f;
    display: flex;
    height: 80px;
    align-items: center;
    font-size: 26px;
}
.levelCodeImg {
    width: 58px;
    height: 34px;
}

.interval {
    height: 20px;
    background: #f9fafc;
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0);
    margin-top: 30px;
}

:deep(.van-search) {
    padding: 30px 30px 30px 30px;
}

:deep(.van-icon__image) {
    height: 28px;
    display: inline-block;
}

:deep(.van-tabs__nav) {
    background-color: #f5f6f7 !important;
}

:deep(.van-list__finished-text) {
    height: 280px !important;
}

:deep(.van-field__left-icon) {
    color: #c8c9cc !important;
    padding: 3px 20px 0 0 !important;
    margin-right: 0 !important;
}
:deep(.van-field__control) {
    font-size: 28px !important;
}
</style>

